export default function Radio({ label, className, ...rest }) {
  return (
    <label className={['ui ui-check ui-check--radio', className].filter(Boolean).join(' ')}>
      <input type="radio" {...rest} />
      <span className="ui-check__box" aria-hidden="true"><span className="ui-check__dot" /></span>
      <span>{label}</span>
    </label>
  );
}
